import { MsisdnSelectItem, useGetUserMsisdnsQuery } from "../../store/features/Msisdns/msisdnService.ts";
import {PhoneHQIconAvatar} from 'ch3-ui-lib';
import { useState, useMemo, useCallback } from "react";
import { buildQueryParams } from "../../utilis/buildQueryParams.ts";
import { useSelector } from "react-redux";
import { selectUserId } from "../../store/features/Auth/authSlice.ts";
import { useFetchMsisdnsAdminQuery } from "../../store/features/MsisdnSettings/msisdnSettingsService.ts";


interface DropdownItem {
    label: JSX.Element;
    prefixElement: JSX.Element;
    value: MsisdnSelectItem;
    key: string;
}


interface UsePhoneNumbersFilterProps {
    selectedNumbers: MsisdnSelectItem[];
    setSelectedNumbers: (numbers: MsisdnSelectItem[]) => void;
    admin?: boolean;
}

interface UsePhoneNumbersFilterReturn {
    phonePhrase: string;
    setPhonePhrase: (phrase: string) => void;
    phoneNumbers: DropdownItem[];
    handlePhoneNumberSelect: (value: MsisdnSelectItem) => void;
    isLoading: boolean;
    error?: any;
    selectedCount: number;
}

export const usePhoneNumbersFilter = ({
                                          selectedNumbers,
                                          setSelectedNumbers,
                                          admin = false
                                      }: UsePhoneNumbersFilterProps): UsePhoneNumbersFilterReturn => {
    const [phonePhrase, setPhonePhrase] = useState<string>('');
    const userId = useSelector(selectUserId);

    const msisdnQueryParams = useMemo(() => buildQueryParams({
        phrase: phonePhrase,
        userId,
    }), [phonePhrase, userId]);

    const { data: userMsisdns, isLoading, error } = admin
        ? useFetchMsisdnsAdminQuery(msisdnQueryParams)
        : useGetUserMsisdnsQuery(msisdnQueryParams);
    console.log('userMsisdns', userMsisdns)
    const selectedCount = useMemo(
        () => selectedNumbers.length,
        [selectedNumbers]
    );

    const phoneNumbers = useMemo((): DropdownItem[] => {
        if (!userMsisdns?.data) return [];

        return userMsisdns.data.map((msisdn: any) => ({
            label: (
                <div className='flex items-center'>
                    {msisdn.label}
                </div>
            ),
            prefixElement: (
                <div className='ml-2'>
                    <PhoneHQIconAvatar icon={msisdn.icon} color={msisdn.iconColor} name='phone number icon' size="24px"/>
                </div>
            ),
            value: msisdn,
            key: String(msisdn.msisdnId)
        }));
    }, [userMsisdns?.data]);

    const handlePhoneNumberSelect = useCallback((value: MsisdnSelectItem) => {
        const exists = selectedNumbers.some((item: MsisdnSelectItem) => item.msisdnId === value.msisdnId);
        const newSelectedNumbers = exists
            ? selectedNumbers.filter((item: MsisdnSelectItem) => item.msisdnId !== value.msisdnId)
            : [...selectedNumbers, value];

        setSelectedNumbers(newSelectedNumbers);
    }, [selectedNumbers, setSelectedNumbers]);

    return {
        phonePhrase,
        setPhonePhrase,
        phoneNumbers,
        handlePhoneNumberSelect,
        isLoading: isLoading || false,
        error,
        selectedCount
    };
};